// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InsuranceTermStep-module__dateBox--yYJ_4 {
   flex-grow: 1;
    padding: 20px;
    border-radius: 16px;
    /* -webkit-box-shadow: 0px 12px 31px -5px rgba(34, 60, 80, 0.14);
    -moz-box-shadow: 0px 12px 31px -5px rgba(34, 60, 80, 0.14);
    box-shadow: 0px 12px 31px -5px rgba(34, 60, 80, 0.14);
    width: 60%; */
    width: 80%;
    margin: 0px auto;
    display: flex;
    flex-direction: column;
}

.InsuranceTermStep-module__btnBoxNext--VYLKE {
    display: flex;
    justify-content: space-between;
}

.InsuranceTermStep-module__titleBox--EGM4S>h4 {
     margin: 0 0 20px 0;
    font-size: 18px;
    font-weight: 500;
    color: var(--color-title);
}

.InsuranceTermStep-module__fieldBox--TBXtw {
    display: flex;
    gap: 20px;
}
.InsuranceTermStep-module__fieldBox--TBXtw > div {
    width: 50%;
}

.InsuranceTermStep-module__colorBox--eLZjX>p>span {
    font-weight: bold;
    color: var(--color-primary);
}

.InsuranceTermStep-module__colorBox--eLZjX {
    margin-bottom: 20px;
    display: flex;
    gap: 10px;
    align-content: center;
    justify-content: center;
    align-items: center;
    background-color: rgb(43 93 235 / 5%);
    border-radius: 20px;
    padding: 5px;
}

.InsuranceTermStep-module__colorBox--eLZjX>p {
    margin: 0;
}

.InsuranceTermStep-module__icon--SCLE3>svg {
    color: var(--color-primary);
    font-size: 25px;
}

@media (max-width: 950px) {
    .InsuranceTermStep-module__fieldBox--TBXtw {
        flex-direction: column;
    }
    .InsuranceTermStep-module__fieldBox--TBXtw > div{
        width: 100%;;
    }
    .InsuranceTermStep-module__dateBox--yYJ_4 {
        width: 80%;
    }
}`, "",{"version":3,"sources":["webpack://./src/features/cancer-protection/step-2/ui/InsuranceTermStep.module.css"],"names":[],"mappings":"AAAA;GACG,YAAY;IACX,aAAa;IACb,mBAAmB;IACnB;;;iBAGa;IACb,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;KACK,kBAAkB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;AACA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,SAAS;IACT,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,qCAAqC;IACrC,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;IACf;IACA;QACI,UAAU;IACd;AACJ","sourcesContent":[".dateBox {\r\n   flex-grow: 1;\r\n    padding: 20px;\r\n    border-radius: 16px;\r\n    /* -webkit-box-shadow: 0px 12px 31px -5px rgba(34, 60, 80, 0.14);\r\n    -moz-box-shadow: 0px 12px 31px -5px rgba(34, 60, 80, 0.14);\r\n    box-shadow: 0px 12px 31px -5px rgba(34, 60, 80, 0.14);\r\n    width: 60%; */\r\n    width: 80%;\r\n    margin: 0px auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.btnBoxNext {\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.titleBox>h4 {\r\n     margin: 0 0 20px 0;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    color: var(--color-title);\r\n}\r\n\r\n.fieldBox {\r\n    display: flex;\r\n    gap: 20px;\r\n}\r\n.fieldBox > div {\r\n    width: 50%;\r\n}\r\n\r\n.colorBox>p>span {\r\n    font-weight: bold;\r\n    color: var(--color-primary);\r\n}\r\n\r\n.colorBox {\r\n    margin-bottom: 20px;\r\n    display: flex;\r\n    gap: 10px;\r\n    align-content: center;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: rgb(43 93 235 / 5%);\r\n    border-radius: 20px;\r\n    padding: 5px;\r\n}\r\n\r\n.colorBox>p {\r\n    margin: 0;\r\n}\r\n\r\n.icon>svg {\r\n    color: var(--color-primary);\r\n    font-size: 25px;\r\n}\r\n\r\n@media (max-width: 950px) {\r\n    .fieldBox {\r\n        flex-direction: column;\r\n    }\r\n    .fieldBox > div{\r\n        width: 100%;;\r\n    }\r\n    .dateBox {\r\n        width: 80%;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dateBox": `InsuranceTermStep-module__dateBox--yYJ_4`,
	"btnBoxNext": `InsuranceTermStep-module__btnBoxNext--VYLKE`,
	"titleBox": `InsuranceTermStep-module__titleBox--EGM4S`,
	"fieldBox": `InsuranceTermStep-module__fieldBox--TBXtw`,
	"colorBox": `InsuranceTermStep-module__colorBox--eLZjX`,
	"icon": `InsuranceTermStep-module__icon--SCLE3`
};
export default ___CSS_LOADER_EXPORT___;
